module.exports = __webpack_public_path__ + "img/bmp.309f48b2.png";